import { combineReducers } from 'redux';
import { user } from './redux/user';
import { menu } from './redux/menu';
import { message } from './redux/message';
import { systemRole } from './redux/system/role';
import { systemMenu } from './redux/system/menu';
import { systemSysParam } from './redux/system/sysParam';
import { systemUser } from './redux/system/user';
import { systemPwdReset } from './redux/system/pwdReset';
import { systemDataDict } from './redux/system/dataDict';
import { systemGroup } from './redux/system/group';
import { systemMatters } from '@redux/system/matters';

/* 系统管理 */
// 公告
import { publicNotice } from './redux/public/notice';
import { publicNoticeAddEdit } from './redux/public/notice-addedit';
// 短信推送
import { messagePush } from './redux/system/messagePush';
// 邮件推送
import { emailPush } from './redux/system/emailPush';
/* 业务管理 */
// 发布线上培训
import { onlineReleaseTraining } from './redux/page/online/releaseTraining';
import { onlineTrainingManagement } from './redux/page/online/trainingManagement';
import { onlineRegistrationManagement } from './redux/page/online/registrationManagement';
import { onlineQybmglPayment } from './redux/page/online/payment';
// 发布线下培训
import { releaseOfflineTraining } from './redux/page/releaseOfflineTraining/index';
// 培训管理
import { trainingManagement } from './redux/page/trainingManagement/trainingManagement';
// 报道管理
import { reportingManagement } from './redux/page/reportingManagement/reportingManagement';
import { reportingManagementOnline } from './redux/page/reportingManagementOnline/reportingManagementOnline';
// 财务管理
import { financialManagement } from './redux/page/financialManagement/financialManagement';
// 缴费开票
import { payment } from './redux/page/financialManagement/payment';
import { qybmglPayment } from './redux/page/qybmgl/payment';
// 签到管理
import { attendanceManagement } from './redux/page/attendanceManagement/attendanceManagement';
// 签到记录
import { attendanceManagementHistory } from './redux/page/attendanceManagement/attendanceManagementHistory';
// 成绩管理
import { scoreManagement } from './redux/page/scoreManagement/scoreManagement';
import { userScoreManagement } from './redux/page/scoreManagement/userScoreManagement';
// 报名管理
import { registrationManagement } from './redux/page/registrationManagement/registrationManagement';
// 成绩明细管理
import { resultDetailManagement } from './redux/page/resultDetailManagement/resultDetailManagement';
// 新发证书
import { newCertificate } from './redux/page/newCertificate/newCertificate';
// 诚信档案
import { creditArchives } from './redux/page/creditArchives/creditArchives';
// 人员信息
import { userManagement } from './redux/page/userManagement/userManagement';
// 企业信息
import { businessManagement } from './redux/page/businessManagement/businessManagement';
// 培训机构管理
import { organManagement } from './redux/page/organManagement/organManagement';
// 题库管理
import { itemBankManagement } from './redux/page/itemBankManagement/itemBankManagement';
// 库存管理
import { inventoryManagement } from './redux/page/inventoryManagement/inventoryManagement';
import { userInventoryManagement } from './redux/page/inventoryManagement/userInventoryManagement';
import { continuingEducation } from './redux/page/continuingEducation/continuingEducation';
// 目录管理
import { dirManagement } from './redux/page/dirManagement/dirManagement';
// 知识点管理
import { knowledgeManagement } from './redux/page/knowledgeManagement/knowledgeManagement';
// 组卷管理
import { testPaperManagement } from './redux/page/testPaperManagement/testPaperManagement';
import { onlineTestPaperManagement } from './redux/page/testPaperManagement/onlineTestPaperManagement';
import { onlineUserPaper } from './redux/page/onlineUserPaper/index';
// 课程管理
import { pageCourseList } from './redux/page/course/list';
// 申请管理
import { applyFor } from './redux/page/applyFor/applyFor';
// 视频题目列表
import { videoItem } from './redux/page/videoItem/videoItem';
// 教师列表
import { teacherS } from './redux/page/teacherS/teacherS';
// 学习记录列表
import { studyRecord } from './redux/page/studyRecord/studyRecord';
// 人才库
import { talentsManagement } from './redux/page/talentsManagement/talentsManagement';
// 人才申请管理
import { talentsApplyFor } from '@redux/page/talentsApplyFor/talentsApplyFor';
// 优秀学员库
import { excellentManagement } from './redux/page/excellentManagement/excellentManagement';
// banner管理
import { publicBanner } from './redux/public/banner';
// 退款记录
import { refundRecord } from './redux/page/refundRecord/refundRecord';

// 延期记录
import { onlineExamDelay } from './redux/page/online/examDelay';
// 培训白名单
import { whiteManagement } from './redux/page/whiteManagement/whiteManagement';
// 培训白名单详情
import { whiteDetailManagement } from './redux/page/whiteDetailManagement/whiteDetailManagement';
export default combineReducers({
  applyFor,
  user,
  menu,
  message,
  systemRole,
  systemMenu,
  systemUser,
  systemPwdReset,
  systemSysParam,
  systemDataDict,
  systemGroup,
  systemMatters,
  messagePush,
  emailPush,
  releaseOfflineTraining,
  trainingManagement,
  reportingManagement,
  reportingManagementOnline,
  financialManagement,
  payment,
  qybmglPayment,
  attendanceManagement,
  attendanceManagementHistory,
  scoreManagement,
  userScoreManagement,
  continuingEducation,
  registrationManagement,
  resultDetailManagement,
  newCertificate,
  creditArchives,
  userManagement,
  publicNotice,
  publicNoticeAddEdit,
  businessManagement,
  organManagement,
  itemBankManagement,
  inventoryManagement,
  userInventoryManagement,
  dirManagement,
  knowledgeManagement,
  testPaperManagement,
  onlineTestPaperManagement,
  onlineUserPaper,
  pageCourseList,
  videoItem,
  teacherS,
  studyRecord,
  onlineReleaseTraining,
  onlineTrainingManagement,
  onlineRegistrationManagement,
  onlineQybmglPayment,
  talentsManagement,
  talentsApplyFor,
  publicBanner,
  refundRecord,
  excellentManagement,
  onlineExamDelay,
  whiteManagement,
  whiteDetailManagement
});
